"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.sync.model.button': 'Sincronizar Modelo',
    'chat.sync.model.tooltip': 'Sincronizar al modelo de conversación',
};
